import React from "react";
import Input from "./Input.jsx";

export default (props) => (
  <div className="labeled-input">
    {props.data_for ? (
      <label data-tip data-for={props.data_for} htmlFor={props.name}>
        {props.label}
      </label>
    ) : (
      <label htmlFor={props.name}>{props.label}</label>
    )}
    <Input
      value={props.value}
      onChange={props.onChange}
      onChange2={props.onChange2}
      placeholder={props.placeholder}
      readOnly={props.readOnly}
      disabled={props.disabled}
      type={props.type}
      min={props.min}
      ref={props.inputRef}
      max={props.max}
      width={props.width}
      disableSpaces={props.disableSpaces}
      onKeyEnter={props.onKeyEnter}
      onKeyDown={props.onKeyDown}
      onFocus={props.onFocus}
      className={props.className}
      target={props.target}
      field={props.field}
      uppercase={props.uppercase}
      style={props.style}
    />
  </div>
);



// WEBPACK FOOTER //
// ./src/lib_react_adminlte/componentes/LabeledInput.jsx